"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReducer = void 0;
const lodash_1 = require("lodash");
const Utils_1 = require("../Utils");
const Keys_1 = require("./Keys");
const Utils_2 = require("./Utils");
const createInitialState = (id) => ({
    error: undefined,
    hash: (0, Utils_1.randomHash)(32),
    id,
    result: undefined,
    status: Keys_1.RequestStatus.Initial,
});
const createReducer = (id) => {
    const initialState = {
        ...createInitialState(id),
        hash: (0, Utils_1.randomHash)(32),
    };
    const reducer = (state = initialState, action) => {
        const update = action.meta && action.meta.update
            ? true
            : false;
        switch (action.type) {
            case (0, Utils_2.createRequestActionType)(Keys_1.RequestActionType.Cancel, id):
                return {
                    ...state,
                    hash: (0, Utils_1.randomHash)(32),
                    error: undefined,
                    meta: action.meta,
                    status: Keys_1.RequestStatus.Loaded,
                };
            case (0, Utils_2.createRequestActionType)(Keys_1.RequestActionType.Clear, id):
                return {
                    ...initialState,
                    hash: (0, Utils_1.randomHash)(32),
                };
            case (0, Utils_2.createRequestActionType)(Keys_1.RequestActionType.Fail, id):
                return {
                    ...state,
                    hash: (0, Utils_1.randomHash)(32),
                    error: action.payload,
                    meta: action.meta,
                    status: Keys_1.RequestStatus.Error,
                };
            case (0, Utils_2.createRequestActionType)(Keys_1.RequestActionType.Load, id):
                return {
                    ...state,
                    hash: (0, Utils_1.randomHash)(32),
                    error: undefined,
                    meta: action.meta,
                    status: Keys_1.RequestStatus.Updating,
                    result: update ? state.result : undefined,
                };
            case (0, Utils_2.createRequestActionType)(Keys_1.RequestActionType.Receive, id):
                const stateValue = state.result && state.result.value;
                const payloadValue = action.payload && action.payload.value;
                const hasValue = stateValue ? true : false;
                let result = action.payload || {};
                if (hasValue) {
                    result.value = (0, lodash_1.isArray)(stateValue)
                        ? (0, lodash_1.unionBy)(stateValue || [], payloadValue, 'id')
                        : (0, lodash_1.merge)(payloadValue || {}, stateValue || {});
                }
                else {
                    result =
                        (!state.result && (0, lodash_1.isArray)(result)) || (0, lodash_1.isArray)(state.result)
                            ? (0, lodash_1.unionBy)(action.payload || [], state.result || [], 'id')
                            : (0, lodash_1.merge)(state.result || {}, action.payload || {});
                }
                if (action.meta && action.meta.update) {
                    delete action.meta.update;
                }
                return {
                    ...state,
                    hash: (0, Utils_1.randomHash)(32),
                    error: undefined,
                    meta: action.meta,
                    result: result,
                    status: Keys_1.RequestStatus.Loaded,
                };
            case (0, Utils_2.createRequestActionType)(Keys_1.RequestActionType.Update, id):
                return {
                    ...state,
                    hash: (0, Utils_1.randomHash)(32),
                    error: undefined,
                    meta: action.meta,
                    result: state.result,
                    status: Keys_1.RequestStatus.Updating,
                };
            default:
                return state;
        }
    };
    return reducer;
};
exports.createReducer = createReducer;
